import * as React from "react";

function SvgReportAndSupport(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 27 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0c-1.657 0-3 1.384-3 3.09v1.546H6v3.091c0 .854.672 1.546 1.5 1.546h12c.828 0 1.5-.692 1.5-1.546v-3.09h-3V3.09C18 1.384 16.657 0 15 0h-3zm0 4.636c0-.853.672-1.545 1.5-1.545s1.5.692 1.5 1.545c0 .854-.672 1.546-1.5 1.546S12 5.49 12 4.636zM0 6.182h4.5v1.545c0 1.707 1.343 3.091 3 3.091h12c1.657 0 3-1.384 3-3.09V6.181H27V34H0V6.182zm15.263 10.716l2.874-2.874a9.224 9.224 0 00-9.357 0l2.873 2.874a5.392 5.392 0 013.61 0zm6.13.382a9.224 9.224 0 010 9.357l-2.874-2.874a5.394 5.394 0 000-3.61l2.873-2.873zm-6.13 9.739l2.874 2.873a9.224 9.224 0 01-9.357 0l2.873-2.873a5.394 5.394 0 003.61 0zM5.524 17.28l2.874 2.873a5.393 5.393 0 000 3.61l-2.874 2.874a9.225 9.225 0 010-9.357zm11.19 1.423c.6.599 1.571.599 2.17 0l1.628-1.628a1.535 1.535 0 00-2.17-2.17l-1.628 1.627c-.6.6-.6 1.571 0 2.17zm1.628-.543a.767.767 0 11-1.085-1.085l1.627-1.628a.767.767 0 111.086 1.085l-1.628 1.628zM6.404 14.905c-.599.599-.599 1.57 0 2.17l1.628 1.628a1.535 1.535 0 002.17-2.17l-1.627-1.629c-.6-.599-1.571-.599-2.17 0zm.543.542c-.3.3-.3.786 0 1.085l1.628 1.628a.767.767 0 101.085-1.085l-1.628-1.628c-.3-.3-.785-.3-1.085 0zm1.628 13.565a1.535 1.535 0 11-2.17-2.17l1.627-1.628a1.535 1.535 0 112.17 2.17l-1.627 1.628zm-1.628-.542c.3.3.786.3 1.085 0l1.628-1.628a.767.767 0 10-1.085-1.085l-1.628 1.627c-.3.3-.3.786 0 1.086zm9.767-1.086a1.535 1.535 0 112.17-2.17l1.628 1.628a1.535 1.535 0 01-2.17 2.17l-1.628-1.628zm.543-.542a.767.767 0 111.085-1.085l1.628 1.627a.767.767 0 11-1.086 1.086l-1.627-1.628z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgReportAndSupport;
